import styled from "styled-components";

export default styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  width: 100%;
  // min-width: 30rem;
  max-width: 1192px;
  // padding: 3rem 0;
  // padding: 8rem 0;
  font-family: "Poppins", "sans-serif";

  // display column on mobile
  @media (max-width: 768px) {
    flex-direction: column;
    // align-items: center;
    // padding: 2rem 0;
  }

  &.unauthenticated {
    position: relative;
    width: 688px;
    &:before {
      content: " ";
      position: absolute;
      z-index: 2;
      backdrop-filter: blur(6px);
      width: 110%;
      height: 110%;
      top: -16px;
      left: -16px;
    }
  }
`;
